module.exports = __webpack_public_path__ + "static/img/logo.f28f67c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 1